export default __webpack_public_path__ + "static/media/Photo 9 - MR - Espace tampons.b77dc582.jpg";